export function SiteFooter() {
  return (
    <footer className="h-10 bg-navy-900 border-t border-white/10 flex items-center justify-center px-6 text-xs text-white/50 shrink-0">
      RegattaReplay &copy; {new Date().getFullYear()}
    </footer>
  );
}
